import axios from 'axios';
import { getPorpoiseSubdomain } from '../../components/api';

/**
 * Axios instance configured for the RenPy API service.
 * 
 * This instance is configured to communicate with the renpy subdomain
 * and includes credentials for authenticated requests.
 */
export const renpyApi = axios.create({
  baseURL: `${getPorpoiseSubdomain('renpy')}/`,
});

const token = localStorage.getItem('token');
if (token) {
  renpyApi.defaults.headers.common.Authorization = token;
}

renpyApi.defaults.headers.post['Content-Type'] = 'application/json';

// Inherit the same withCredentials setting as the main API
if (!window?.location?.hostname.endsWith('localhost')) {
  renpyApi.defaults.withCredentials = true;
}

